var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2569,
    height: 644,
    viewBox: "0 0 2569 644",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M322 644C499.836 644 644 499.836 644 322C644 144.164 499.836 0 322 0C144.164 0 0 144.164 0 322C0 499.836 144.164 644 322 644ZM322.562 110.901C351.673 232.569 411.61 344.696 496.605 436.49L537.74 480.916C399.376 426.742 244.707 426.989 106.246 480.916L148.915 435.44C234.326 344.41 294.222 232.467 322.562 110.901Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.22 437.919H1036.71L1011.93 378.612H895.965L871.179 437.919H834L932.922 206H976.297L1075.22 437.919ZM909.685 345.638H998.206L953.946 239.859L909.685 345.638Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1280.67 437.697H1108.06V206H1144.13V404.06H1280.67V437.697Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1488.21 437.697H1315.6V206H1351.67V404.06H1488.21V437.697Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1559.21 437.697H1523.14V206H1559.21V437.697Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1833.63 437.919H1795.12L1770.34 378.612H1654.37L1629.59 437.919H1592.41L1691.33 206H1734.71L1833.63 437.919ZM1668.1 345.638H1756.62L1712.36 239.859L1668.1 345.638Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2076.04 438.14H2042.63L1902.54 266.193V437.919H1866.47V206H1899.89L2040.19 378.169V206.222H2076.04V438.14Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2247.82 203C2268.92 203 2288.17 207.5 2305.58 216.499C2322.99 225.351 2336.49 237.817 2346.08 253.898L2315.76 272.487C2308.68 261.422 2299.16 252.792 2287.21 246.595C2275.41 240.399 2262.28 237.301 2247.82 237.301C2223.92 237.301 2204.08 245.268 2188.29 261.201C2172.65 276.987 2164.83 297.346 2164.83 322.279C2164.83 347.802 2172.73 368.382 2188.51 384.02C2204.3 399.659 2224.07 407.478 2247.82 407.478C2262.28 407.478 2275.41 404.453 2287.21 398.405C2299.16 392.208 2308.75 383.578 2315.98 372.513L2345.19 393.315C2334.57 408.658 2320.85 420.608 2304.03 429.165C2287.21 437.722 2268.48 442 2247.82 442C2212.86 442 2184.01 430.788 2161.29 408.363C2138.57 385.791 2127.21 357.096 2127.21 322.279C2127.21 287.461 2138.57 258.914 2161.29 236.637C2184.01 214.212 2212.86 203 2247.82 203Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2569 437.697H2393.06V206H2569V238.973H2429.14V304.477H2569V337.45H2429.14V404.724H2569V437.697Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.9015a1a7c55be4d5c9bf260e052d88b3.svg";
export { ForwardRef as ReactComponent };